import { useEffect } from 'react';

export const useStylesheet = (href: string) => {
  useEffect(() => {
    if (document.head.querySelector(`link[href="${href}"]`)) {
      return;
    }

    const link = document.createElement('link');

    link.rel = 'stylesheet';
    link.href = href;
    link.crossOrigin = 'anonymous';
    document.head.append(link);
  }, [href]);
};
